<script setup lang="ts" generic="T">
  import { LoadingSpinner } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    items: T[]
    searchTerm: string
    loading?: boolean
    error?: string | null
  }>()

  const emit = defineEmits<{
    (e: 'select', item: T): void
  }>()
</script>

<template>
  <template v-if="error">
    <p class="error-message">{{ error }}</p>
  </template>
  <template v-else-if="loading">
    <LoadingSpinner />
  </template>
  <div class="list" v-else>
    <template v-if="searchTerm && items.length === 0">
      <p>No results</p>
    </template>
    <template v-else>
      <div
        class="list-item"
        v-for="(item, index) in items"
        :key="index"
        role="button"
        @click="emit('select', item)"
      >
        <slot name="item" :item="item" />
      </div>
    </template>
  </div>
</template>

<style scoped>
  .list {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    width: var(--layout-8-col-text-max);
    height: 100%;
  }

  .list-item {
    display: flex;
    width: 100%;
    padding: var(--spacing-xs);
    align-items: center;
    justify-content: center;
    gap: var(--spacing-m);
    position: relative;
    transition:
      background 160ms ease,
      transform 160ms ease;
    cursor: pointer;
  }

  .list-item:hover {
    background: var(--colours-grey-2);
    transform: translateY(-0.0625rem);
  }

  .error-message {
    color: var(--colours-support-error);
  }
</style>
